<template>
  <v-container>
    <!-- <v-row class="text-center">
      
      
    </v-row> -->
    <Main :returnStartPageThis="returnStartPageThis" v-if="mode === 'main'" />
    <Results
      :returnStartPageThis="returnStartPageThis"
      :correct="correct"
      v-else-if="mode === 'results'"
    />
    <span v-else-if="mode === 'count_down'">
      {{ remain }}
    </span>

    <span v-else>
      <!-- <v-btn
        @click="
          () => {
            unlock_autoplay();
            countDown();
          }
        "
        >Start</v-btn
      > -->
      <v-img
        src="play.png"
        @click="
          () => {
            unlock_autoplay();
            countDown();
          }
        "
      >
      </v-img>
    
      <span class="text-h6 text-center mx-2 py-10">
        <br>
      タイトル画面時のきらファンボイスが誰かを当てるクイズです<br>

      </span>

    </span>
  </v-container>
</template>

<script>
import Main from "../../components/quiz_main";
import Results from "../../components/results";

export default {
  props: ["returnHomeThis"],
  components: {
    Main,
    Results,
  },

  data: () => ({
    group: null,

    mode: "",
    modeList: {
      main: "main",
      results: "results",
      count_down: "count_down",
      home: "home",
    },

    db: {},
    voice_URL_list: {},

    audio: undefined,

    // remain: 3,
    // interval_id: 0,

    playTime: 5,
    nowPlaying: 1,
    correct: 0,

    Questioned: [],
    remainQuestionable: [],

    nowPlayingQuizID: 0,
  }),

  computed: {
    returnStartPageThis() {
      // console.log(this);
      return this;
    },
  },

  methods: {
    unlock_autoplay() {
      let audio = new Audio(require("../../assets/noSound.old.mp3"));
      audio.onplaying = () => {
        audio.pause();
      };
      audio.play();
    },
    countDown() {
      this.remain = "start";
      // this.mode = this.modeList.count_down;
      this.quizStart();

      // this.interval_id = setInterval(() => {
      //   if (this.remain === "start") {
      //     clearInterval(this.interval_id);
      //     this.quizStart();
      //   }else if( this.remain === 1){
      //      this.remain = "start"
      //   }else{
      //      this.remain--
      //   }
      // }, 1000);
    },
    async play(url) {
      if (this.audio) {
        this.audio.pause();
      }
      this.audio = new Audio(this.voice_URL_list[url]);
      this.audio.volume = 0.5;
      this.audio.play();
    },

    quizStart() {
      this.mode = this.modeList.main;
      // this.remainQuestionable = this.db;
    },
    quiz() {},
  },

  mounted() {
    const homeThis = this.returnHomeThis;
    this.db = homeThis.db;
    this.voice_URL_list = homeThis.voice_URL_list;

    // this.remainQuestionable = this.db;

    // console.log(

    //   require("../../assets/noSound.mp3")
    // );
    // this.play("Gochiusa_Syaro")
    this.mode = this.modeList.home;
  },
};
</script>
